import React, { useEffect, useState } from "react";
import "./Servicespage.scss";
import { useNavigate } from "react-router-dom";

const API = "https://api.ainfotech.com.np";

const ServicesShowcase = () => {
  const navigate = useNavigate();
  const open = (slug) => navigate(`/services/${slug}`);

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${API}/api/services?status=published&page=1&limit=50`);
        const data = await res.json();
        if (!res.ok) throw new Error(data?.error || "Failed to fetch services");
        setRows(Array.isArray(data.items) ? data.items : []);
      } catch (e) {
        console.error(e);
        setRows([]);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) {
    return (
      <section className="services-section">
        <div className="container">Loading…</div>
      </section>
    );
  }

  return (
    <section className="services-section">
      <div className="container">
        <div className="svc-grid">
          {rows.map((svc) => {
            const cover = svc.cover_image ? `${API}${svc.cover_image}` : undefined;
            return (
              <article
                key={svc.id}
                className="svc-card"
                onClick={() => open(svc.slug)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    open(svc.slug);
                  }
                }}
                role="button"
                tabIndex={0}
                aria-label={`Open ${svc.title}`}
              >
                <div
                  className="svc-media"
                  style={{ backgroundImage: cover ? `url(${cover})` : undefined }}
                  aria-hidden="true"
                />
                <div className="svc-info">
                  <div className="svc-meta" role="heading" aria-level={3}>
                    <h3 className="svc-name">{svc.title}</h3>
                  </div>
                  <p className="svc-text">{svc.excerpt || ""}</p>
                  <button
                    className="svc-read"
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      open(svc.slug);
                    }}
                  >
                    <span className="pipe" aria-hidden="true">|</span> READ MORE
                  </button>
                </div>
              </article>
            );
          })}
          {rows.length === 0 && <div>No services found.</div>}
        </div>
      </div>
    </section>
  );
};

export default ServicesShowcase;
